import { useInView } from 'react-intersection-observer';

import '../../styles/Animator.css';

export function Animator({ component }) {

  const [ref, inView] = useInView({
    triggerOnce: true
  });

  const animations = ['slideUp', 'pullUp', 'stretchLeft', 'stretchRight'];
  const index = Math.floor(Math.random() * 3);

  return(
    <div ref={ref} className={`${inView ? animations[index] : ''}`}>
      { component }
    </div>
  );
}